import { useEffect, useState } from "react";
import { PageHeader } from "@/components/DashboardShell";
import { Stat } from "@/components/brand";
import api from "@/lib/api";

export default function AdminReports() {
  const [s, setS] = useState(null);
  useEffect(() => { (async () => { const { data } = await api.get("/stats/admin"); setS(data); })(); }, []);

  return (
    <div>
      <PageHeader index="06" eyebrow="Reporting" title="Network reporting" />

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200 border border-gray-200 mb-8">
        {[
          ["Pending applications", s?.pending_applications],
          ["Approved drivers", s?.approved_drivers],
          ["Merchants", s?.merchants],
          ["Total deliveries", s?.total_deliveries],
          ["Active deliveries", s?.active_deliveries],
          ["Approval turnaround", s ? `${s.avg_turnaround_hours}h` : null],
        ].map(([k, v]) => (
          <div key={k} className="bg-white p-6">
            <Stat label={k} value={v ?? "—"} />
          </div>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 gap-6">
        <div className="border border-gray-200 p-6">
          <div className="font-mono text-[11px] tracking-[0.14em] uppercase text-gray-400 mb-3">Review SLA</div>
          <div className="text-3xl font-bold text-[#0a0a0a]">{s ? `${s.avg_turnaround_hours}h` : "—"}</div>
          <div className="text-sm text-gray-500 mt-1">Avg turnaround vs ≤ 48h target</div>
          <div className="mt-4 h-2 bg-gray-100">
            <div className="h-full bg-orange-500" style={{ width: `${Math.min(100, ((s?.avg_turnaround_hours || 0) / 48) * 100)}%` }} />
          </div>
        </div>
        <div className="border border-gray-200 p-6">
          <div className="font-mono text-[11px] tracking-[0.14em] uppercase text-gray-400 mb-3">Driver compliance rate</div>
          <div className="text-3xl font-bold text-[#0a0a0a]">{s ? `${s.compliance_rate}%` : "—"}</div>
          <div className="text-sm text-gray-500 mt-1">Drivers with current licences</div>
          <div className="mt-4 h-2 bg-gray-100">
            <div className="h-full bg-[#0a0a0a]" style={{ width: `${s?.compliance_rate || 0}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
}
